module.exports = __webpack_public_path__ + "static/media/3.11_preview.947c81b2.png";